module.exports = __webpack_public_path__ + "img/libya.10a391ce.svg";